import React, { useRef } from 'react';

import classNames from 'classnames';

import { IEventTag } from '../../../../types/working-model';
import { OptionalComponent } from '../../../../utils/optional-component';
import { Tooltip } from '../../../general-ui/tooltip/tooltip';
import { useGetAdjustedTagsCount } from './hooks/sessionTags.hooks';

interface ISessionTagsProps {
	tags: IEventTag[];
	className?: string;
}

function SessionTags({ tags, className }: ISessionTagsProps): JSX.Element {
	const tagsContainerRef = useRef<HTMLDivElement | null>(null);
	const { showedTags, hiddenTags } = useGetAdjustedTagsCount({ tags, tagsContainerRef });

	const shouldShowTagsCountNumber = tags.length && hiddenTags.length;

	const tooltipTagsList = (<>{hiddenTags.map(({ uuid, name }) => <p key={uuid}>{name}</p>)}</>);

	return (
		<div className={classNames('agenda-session-card-tags', className)} ref={tagsContainerRef}>
			{showedTags?.map(({ uuid, name, color }: IEventTag) => (
				<span
					key={uuid}
					className='session-tag'
					style={{ color, backgroundColor: `${color}1a` }}
				>
					{name}
				</span>
			))}

			<OptionalComponent display={!!shouldShowTagsCountNumber}>
				<Tooltip tooltip={tooltipTagsList} position='bottom-center'>
					<div className={classNames('session-tags-number')}>
						{`+${hiddenTags?.length}`}
					</div>
				</Tooltip>
			</OptionalComponent>
		</div>
	);
}

export default SessionTags;
